import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { removeGarmentB2B } from "../../../services/OrdersAPI/Orders";

export default function B2BOrderDeleteModal({
  deleteOrderModal,
  setDeleteOrderModal,
  sendDataToOrderInfoPage,
  storeId,
  storeCustomerId,
  bookingOrderId,
  itemId,
}) {
  const navigate = useNavigate();
 
  const handleConfirmDeleteOrder = () => {
       
    removeGarmentB2B(storeId, storeCustomerId, bookingOrderId, itemId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;
              if (status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              }
              sendDataToOrderInfoPage({
                info: true,
              });
            
              setDeleteOrderModal(false);
            }
          }
        })
        .catch((err) => {
          console.error("Delete Error:", err);
        });
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setDeleteOrderModal(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={deleteOrderModal}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!deleteOrderModal) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-cart-minus"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Confirm Delete Garment
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
             
            <div>
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">If Garment Delete, QRCode Will Also Be Deleted</p>
            </div>

            <Button
              onClick={handleConfirmDeleteOrder}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                YES
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
